import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <span
    className={`font-mono-brand uppercase tracking-[0.25em] text-base font-bold inline-flex items-center gap-2 ${
      light ? "text-ember-light" : "text-ember"
    }`}
  >
    <span className={`w-8 h-px ${light ? "bg-ember-light" : "bg-ember"}`} />
    {children}
  </span>
);
